import {
  getLinkToBrandPageViaId,
  getLinkToCategoryPageViaId,
  getLinkToDepartmentPageViaId,
  getLinkToShopForUserId,
  getLinkToShopForCuratorGroup
} from './shop_helpers';

export const getFeaturedResultType = feature => {
  if (!feature) return null;
  if (feature.user) return 'curator';
  if (feature.group) return 'circle';
  if (feature.brand) return 'brand';
  if (feature.category || feature.department) return 'category';
  return null;
};

export const getFeaturedTypeDisplayData = type => {
  switch (type) {
    case 'curator':
    case 'curators':
      return {
        pluralType: 'Curators',
        singularType: 'Curator'
      };
    case 'circle':
    case 'circles':
    case 'group':
    case 'groups':
      return {
        pluralType: 'Circles',
        singularType: 'Circle'
      };
    case 'brand':
    case 'brands':
      return {
        pluralType: 'Brands',
        singularType: 'Brand'
      };
    case 'category':
    case 'categories':
    case 'catalog':
      return {
        pluralType: 'Categories',
        singularType: 'Category'
      };
    default:
      return [];
  }
};

export const getFeatureDisplayData = feature => {
  if (!feature) return {};

  const type = getFeaturedResultType(feature);

  let displayData = {};
  if (type === 'curator')
    displayData = {
      title: feature.user.name,
      description: feature.description,
      image: feature.image,
      link: getLinkToShopForUserId(feature.user.id, { tab: 'latest' }),
      linkDisplay: 'Shop Latest Finds'
    };
  else if (type === 'circle')
    displayData = {
      title: feature.group.title,
      description: feature.description,
      image: feature.image,
      link: getLinkToShopForCuratorGroup(feature.group, { tab: 'popular' }),
      linkDisplay: 'Shop Popular Finds'
    };
  else if (type === 'brand')
    displayData = {
      title: feature.brand.name,
      description: feature.description,
      image: feature.image,
      link: getLinkToBrandPageViaId(feature.brand.id),
      linkDisplay: 'Shop Popular Finds'
    };
  else if (type === 'category')
    displayData = {
      title: feature.category?.name || feature.department?.name,
      description: feature.description,
      image: feature.image,
      link: feature.category ? getLinkToCategoryPageViaId(feature.category.id) : getLinkToDepartmentPageViaId(feature.department.id),
      linkDisplay: 'Shop Popular Finds'
    };
  return {
    ...displayData,
    ...getFeaturedTypeDisplayData(type)
  };
};

export const getShopFeaturedResultsForType = (featured, type, activeSectionLabel) => {
  const features = featured.shopFeatures
    ? featured.shopFeatures.filter(feature => !activeSectionLabel || feature.labels.includes(activeSectionLabel))
    : featured;
  switch (type) {
    case 'curator':
    case 'curators':
      return features.filter(feature => getFeaturedResultType(feature) === 'curator');
    case 'circle':
    case 'circles':
    case 'group':
    case 'groups':
      return features.filter(feature => getFeaturedResultType(feature) === 'circle');
    case 'brand':
    case 'brands':
      return features.filter(feature => getFeaturedResultType(feature) === 'brand');
    case 'category':
    case 'categories':
    case 'catalog':
      return features.filter(feature => getFeaturedResultType(feature) === 'category');
    default:
      return [];
  }
};
